const getFiltersFromURL = () => {
  if (typeof window === "undefined") return {};

  try {
    const url = new URL(window.location.href);
    const filterParam = url.searchParams.get("filter");

    if (filterParam) {
      const decodedFilter = decodeURIComponent(filterParam);
      return JSON.parse(decodedFilter);
    }
    return {};
  } catch (error) {
    console.warn("Could not parse filters from URL:", error);
    return {};
  }
};

export default getFiltersFromURL;
